import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
  Typography,
} from "@material-ui/core";
import { Resources, useResource } from "Translations/Resources";
import { isNullOrEmpty } from "Utils/StringUtils";
import styled from "styled-components";

export const StyledError = styled.div`
  color: ${props => props.theme.colors.red};
  font-style: italic;
  padding-bottom: ${props => props.theme.spacing(1)}px;
  align-self: flex-end;
`;

type Props = {
  ticketID: number;
  onConfirm: (changeReason: string) => void;
  onCancel: () => void;
};

export const TicketCancelComponent: React.FunctionComponent<Props> = props => {
  const { onCancel, onConfirm } = props;
  const { t } = useResource();
  const [state, setState] = React.useState({
    open: true,
    value: "",
  });

  const [reasonError, setReasonErrors] = React.useState<string>();

  const handleChange = (event: any) => {
    setState({
      ...state,
      value: event.target.value,
    });
    setReasonErrors(undefined);
  };

  const close = () => {
    setState({
      ...state,
      open: false,
    });
  };

  const closeAndCancel = () => {
    close();
    onCancel();
  };

  const handleConfirm = () => {
    if (isNullOrEmpty(state.value)) {
      setReasonErrors(t(Resources.Dashboard.Tickets.Modal.Error));
      return;
    }
    close();
    onConfirm(state.value);
  };

  return (
    <Dialog open={state.open} onClose={closeAndCancel}>
      <DialogTitle id="form-dialog-title">
        {t(Resources.Dashboard.Tickets.Modal.Title)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(Resources.Dashboard.Tickets.Modal.Text)}
        </DialogContentText>
        <TextField
          autoFocus
          multiline={true}
          id={"changeReason"}
          label={t(Resources.Dashboard.Tickets.Modal.InputLabel)}
          value={state.value}
          onChange={handleChange}
          inputProps={{ maxLength: 512 }}
          rows={3}
          fullWidth
        />
        <StyledError>
          {reasonError && <Typography>{reasonError}</Typography>}
        </StyledError>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeAndCancel} color="secondary">
          {t(Resources.Dashboard.Tickets.Modal.Close)}
        </Button>
        <Button
          onClick={e => {
            handleConfirm();
          }}
          color="primary"
        >
          {t(Resources.Dashboard.Tickets.Modal.Confirm)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
